import { FC } from 'react';
import { Form, Input } from 'antd';
import classes from './index.module.less';
interface TextFieldInputInterface {
  className?: string;
  name: string;
  label: string;
  rules?: any;
  placeholder?: string;
}
const TextField: FC<TextFieldInputInterface> = ({
  name,
  label,
  rules,
  placeholder,
  className
}) => {
  return <Form.Item name={name} label={label} rules={rules} className={`${classes['text-field-box']} ${className}`}>
			<Input placeholder={placeholder} className={classes['text-field-input']} />
		</Form.Item>;
};
export default TextField;